export default __webpack_public_path__ + "static/logo-91ecad1eea0f68bb2795ad3d9ca115e6.png";